<template>
  <div>
    <loading :active="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
    <div class="nav-wrapper" :style="'background-color: ' + this.retorno.empresa.cor_primaria">
      <!-- <span class="white-text waves-effect waves-light" @click="openEmpresaUrl" style="display: inline-block; vertical-align: middle; cursor: pointer;">
        <i style="padding-left: 12px; padding-top: 7px;" class="material-icons md-30">arrow_back</i>
      </span> -->
      <span class="white-text waves-light" style="display: inline-block; vertical-align: middle;">
        <i :style="'padding-left: 1px; padding-top: 7px; color: ' + this.retorno.empresa.cor_primaria" class="material-icons md-30">arrow_back</i>
      </span>
      <span class="white-text center-align" style="display: inline-block; vertical-align: middle; flex: 1; padding-left: 10px;">
        <strong style="font-weight: 900;">{{ this.retorno.empresa.nome }}</strong>
      </span>
    </div>
    <ul class="collapsible">
      <li>
        <div class="collapsible-header"><i class="material-icons">assignment_turned_in</i>Detalhes Pedido Nº {{this.retorno.pedido.numero_pedido}}</div>
        <div class="collapsible-body">
          <div class="pedido-html" v-html="this.retorno.pedido.pedido_html"></div>
        </div>
      </li>
      <li>
        <div class="collapsible-header"><i class="material-icons">payments</i>Detalhes do pagamento</div>
        <div class="collapsible-body">
          <div v-if="this.retorno.pedido.forma_pagamento == 'MERCADOPAGO_PIX'" class="paghiper">
            <bloco v-if="this.retorno.pedido.status == 'PROCESSANDO_PAGAMENTO'" id="MERCADOPAGO_PIX_CAIXA_PAGAMENTO">
              <div class="bloco-lista">
                <div class="col" style="padding-top: 8px">
                  <div class="row">
                    <div class="col s12">
                      <label class="grey-text text-darken-4">
                        <span>
                          <span>
                            <center>
                              <div class=" max-width: 100%;">
                                <p style="padding: 5px; word-wrap: break-word;font-size: small; user-select: text;">
                                  {{ this.mercadopago_pix.codigo_copia_cola }}
                                </p>
                              </div>
                              <button @click="CopiarParaAreaDeTransferenciaChavePix()">Copiar Código </button>
                              <br>
                              <img style="padding-top: 7px;max-width: 75%" alt="Código pagamento PIX Online"
                                  :src="'data:image/png;base64,' + this.mercadopago_pix.imagem_qrcode"/>
                          </center>
                          </span>
                          <center>
                              <strong style="color: #bdbdbd;font-size: 12px;">Aguardando pagamento...</strong><br>
                              <img height="100" src="@/assets/aguardando.gif"/>
                          </center>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </bloco>
          </div>
          <div v-if="this.retorno.pedido.forma_pagamento == 'PAGHIPER_PIX'" class="paghiper">
            <bloco  v-if="this.retorno.pagamento.status == 'AGUARDANDO'" id="PAGHIPER_PIX_CAIXA_PAGAMENTO" >
              <titulo-destacado titulo="Dados do PIX Online">
                <span  class="tb-fit material-icons md-30 cor-primaria-text">check_circle_outline</span>
              </titulo-destacado>
              <div class="bloco-lista">
                <div v-if="this.paghiper_pix.imagem_qrcode" class="col" style="padding-top: 8px">
                  <div class="row">
                    <div class="col s12">
                      <label class="grey-text text-darken-4">
                        <span>
                          <span>
                            <center>
                              <div class=" max-width: 100%;">
                                <p style="padding: 5px; word-wrap: break-word;font-size: small; user-select: text;">
                                  {{ this.paghiper_pix.codigo_copia_cola }}
                                </p>
                              </div>
                              <button @click="CopiarParaAreaDeTransferenciaChavePix()">Copiar Código </button>
                              <br>
                              <img style="padding-top: 7px;max-width: 75%" alt="Código pagamento PIX Online"
                                  :src="'data:image/png;base64,' + this.paghiper_pix.imagem_qrcode"/>
                          </center>
                          </span>
                          <center>
                              <strong style="color: #bdbdbd;font-size: 12px;">Aguardando pagamento...</strong><br>
                              <img height="100" src="@/assets/aguardando.gif"/>
                          </center>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
                <div v-else class="col" style="padding-top: 8px">
                  <div class="row">
                    <div class="col s12">
                      <label class="grey-text text-darken-4">
                        <center>
                              <strong style="color: #bdbdbd;font-size: 12px;">Dados de pagamento não encontrados.</strong>
                        </center>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </bloco>
          </div>
          <div v-if="this.retorno.pedido.forma_pagamento == 'MERCADOPAGOLINK'" class="paghiper">
            <bloco  v-if="this.retorno.pedido.status == 'PROCESSANDO_PAGAMENTO'" id="PAGHIPER_PIX_CAIXA_PAGAMENTO" > 
              <div class="bloco-lista">
                <center v-if="this.link_pagamento">
                  <button class="btn waves-effect waves-light" style="margin: 9px;" type="button" @click="AbrirLinkPagamento()">
                    Link de Pagamento
                  </button>
                </center>
                <center v-if="this.link_pagamento_chave_rastreamento">
                  <button class="btn waves-effect waves-light" type="button" @click="AcompanharLinkPagamento()">
                    Acompanhar Status
                  </button>
                </center>
              </div>
            </bloco>
            <bloco v-if="this.retorno.pedido.status != 'PROCESSANDO_PAGAMENTO'" >
              <div class="row">
                    <div class="col s12">
                      <label class="grey-text text-darken-4">
                        <center>
                              <strong style="color: #bdbdbd;font-size: 20px; display: flex;">Pagamento confirmado <span style="margin-left: 4px;" class="tb-fit material-icons md-30 cor-primaria-text">check_circle_outline</span></strong>
                        </center>
                      </label>
                    </div>
                  </div>
            </bloco>            
          </div>
          <bloco v-if="this.retorno.pedido.status != 'PROCESSANDO_PAGAMENTO' && this.retorno.pedido.status != 'CANCELADO' " >
              <div class="row">
                    <div class="col s12">
                      <label class="grey-text text-darken-4">
                        <center>
                              <strong style="color: #bdbdbd;font-size: 20px; display: flex;">Pagamento confirmado <span style="margin-left: 4px;" class="tb-fit material-icons md-30 cor-primaria-text">check_circle_outline</span></strong>
                        </center>
                      </label>
                    </div>
                  </div>
          </bloco>
        </div>
      </li>
      <li class="active" v-if="this.$store.state.empresa.modulo_entregador == 'ATIVO'">
        <div class="collapsible-header"><i class="material-icons">place</i>Acompanhar</div>
          <div class="collapsible-body">
            <div class="timeline">
              <div class="timeline-event" v-for="status in this.retorno.historico" :key="status.id" :id="'status-' + status.id" >
                  <div class="card timeline-content">
                    <div class="card-content">
                      <p>
                        <strong style="font-weight: 900;"> {{getFriendlyStatus(status.status)}}</strong>
                        <br>
                        <strong>{{status.data}}</strong>
                        <br>
                        <strong>{{getStatusDescription(status.status)}}</strong>
                      </p>
                    </div>
                  </div>
                  <div class="timeline-badge lighten-3  white-text">
                    <span class="material-icons md-16 ">{{ getIcon(status.status) }}</span>
                  </div>
              </div>
            </div>
            <center v-if="this.liberarBotaoAtualizar">
                <button class="btn waves-effect waves-light" type="button" @click="refreshPage">
                  Atualizar
                </button>
            </center>
        </div>
      </li>
    </ul>
    <center v-if="PodeEnviarPedido()"> 
        <button class="btn waves-effect waves-light" type="button" @click="this.EnviarPedido">
          Enviar Pedido WhatsApp 
        </button>
    </center>
    <div style="height: 300px;"></div>
  </div>

</template>

<script>
import axios from 'axios'
import NavBarOnly from "../../Widgets/NavBarOnly";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import SecureLS from "secure-ls";
import Cookies from 'js-cookie';
import MenuSuperior from "../../Widgets/MenuSuperior";
import Bloco from "../../Widgets/Bloco.vue";
import TituloDestacado from "../../Widgets/TituloDestacado";
import {WMCompose, WMSend} from '@aninga/whatsapp-manager';
import moment from 'moment-timezone';
import Swal from 'sweetalert2';

export default {
  name: "StatusPedido",
  components: {
    NavBarOnly,
    Loading,
    TituloDestacado,
    Bloco,
    MenuSuperior
  },
  data () {
    return {
      isLoading: false,
      empresaExiste: false,
      fullPage: true,
      liberarBotaoAtualizar: false,
      retorno: {
        empresa: {
          cor_primaria: '#000000',
          empresa_url: ''
        },
        pedido: {
          html:''
        },
        historico: []

      },
      contas: this.$store.state.empresa.contas,
      bandeira_vale_refeicao: null,
      conta_bancaria: null,
      link_pagamento: '',
      link_pagamento_chave_rastreamento: '',
      numero_pedido: 0,
      taxa_entrega_v2: '',
      bairro_id: "",
      nome_cliente: '',
      precisa_troco: false,
      cpf_nota: false,
      cpf: '',
      telefone: '',
      troco_para_quanto: 0,
      forma_pagamento: this.$store.state.empresa.pagamento_dinheiro == "S" ? "DINHEIRO" : "",
      forma_pagamento_obs: "",
      endereco: {
        cep: '',
        endereco: '',
        numero: '',
        bairro: '',
        complemento: '',
        uf: 'RO',
        cidade_nome: '',
        salvo_local: false
      },
      isLoading: false,
      fullPage: true,
      enderecos_offline: [
        {
          cep: '',
          endereco: '',
          numero: '',
          bairro: '',
          bairro_id: '',
          complemento: '',
          uf: '',
          cidade_nome: '',
        }
      ],
      endereco_offiline_selecionado: null,
      novo_endereco: false,
      endereco_entrega_valido: false,
      dados_pessoa_valido: false,
      ocultarcep: false,
      sobairro: false,
      _mercadopago: null,
      _mercadopagoCardForm:null,
      mercadopagoCardFormLiberado:false,
      _mercadopago_checar_pagamento_intervalo: null,
      mercadopago_pagamento_realizado:false,
      mercadopago_pagamento_cartao_descricao_forma_pagamento:"",
      mercadopago_pagamento_chave_rastreamento:"",
      mercadopago_pix_gerado: false,
      mercadopago_pix_pagamento_realizado: false,
      mercadopago_pix: {
        codigo_copia_cola: "",
        imagem_qrcode: "",
        chave_rastreamento:""
      },
      pedido_enviado: false,
      softexpress_cartao:{
        pagamento_realizado: false,
        pagamento_chave_rastreamento:""
      },
      _paghiper_checar_pagamento_intervalo: null,
      paghiper_pix:{
        gerado: false,
        pagamento_realizado: false,
        codigo_copia_cola: "",
        imagem_qrcode: "",
        chave_rastreamento:""
      },
      horariosSelecionados: [],
      pedidoEnviadoLinkText: ""      
    }
  },
  methods:{
    async VerificarEmpresa()
    {
        this.isLoading = true;
        this.$store.commit('empresaUrl', this.$router.currentRoute.params.empresa);
        await axios.get(this.$store.state.apiUrl + 'empresa/' + this.$store.state.empresa_url)
        .then(res => {
          if(res.data) {
            this.isLoading = false;
            this.$store.commit('empresa', res.data);
            this.empresaExiste = true;
          }
        })
        .catch(error => this.isLoading = false);

        if(!this.empresaExiste){
          window.open(this.retorno.empresa.empresa_url, '_blank');
        }
       
          
    },
    openEmpresaUrl() {
      if (this.retorno && this.retorno.empresa && this.retorno.empresa.empresa_url) {
        window.open(this.retorno.empresa.empresa_url, '_blank');
      }
    },
    refreshPage(){
      location.reload();
    },
    AcompanharLinkPagamento() {
      if(this.link_pagamento_chave_rastreamento){
        window.open('/' + this.link_pagamento_chave_rastreamento, '_blank');
      }
    },
    AbrirLinkPagamento() {
      if(this.link_pagamento_chave_rastreamento){
        window.open(this.link_pagamento, '_blank');
      }
    },
    CopiarParaAreaDeTransferenciaChavePix() {
      const input = document.createElement('input');

      if(this.forma_pagamento == 'MERCADOPAGO_PIX')
        input.value = this.mercadopago_pix.codigo_copia_cola;

      if(this.forma_pagamento == 'PAGHIPER_PIX')
        input.value = this.paghiper_pix.codigo_copia_cola;

      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      alert('Código copiado! Aguardando pagamento...');
    },    
    getIcon(status) {
        switch (status) {
          case 'AGUARDANDO':
              return 'hourglass_empty'; // Aguardando
          case 'RECEBIDO':
              return 'assignment_turned_in'; // Recebido
          case 'CANCELADO':
              return 'cancel'; // Cancelado
          case 'ENVIADO':
              return 'two_wheeler'; // Enviado
          case 'PREPARANDO':
              return 'restaurant_menu'; // Preparando
          case 'ENTREGUE':
              return 'check_circle'; // Entregue
          case 'PRONTOPARARETIRADA':
              return 'store'; // Pronto para Retirada
          case 'PRONTOPARAENTREGA':
              return 'two_wheeler'; // Pronto para Entrega
          case 'PROCESSANDO_PAGAMENTO':
              return 'payment'; // Processando Pagamento
          case 'ENDERECO_NAO_LOCALIZADO':
              return 'location_off'; // Endereço Não Localizado
          case 'RECUSOU_RECEBER':
              return 'block'; // Recusou Receber
          default:
              return 'help_outline'; // Status Desconhecido
        }
    },
    getFriendlyStatus(status) {
        switch (status) {
            case 'AGUARDANDO':
                return 'Aguardando';
            case 'RECEBIDO':
                return 'Recebido';
            case 'CANCELADO':
                return 'Cancelado';
            case 'ENVIADO':
                return 'Enviado';
            case 'PREPARANDO':
                return 'Preparando';
            case 'ENTREGUE':
                return 'Entregue';
            case 'PROCESSANDO_PAGAMENTO':
                return 'Processando Pagamento';
            case 'PRONTOPARARETIRADA':
                return 'Pronto para Retirada';
            case 'PRONTOPARAENTREGA':
                return 'Pronto para Entrega';
            case 'ENDERECO_NAO_LOCALIZADO':
                return 'Endereço Não Localizado';
            case 'RECUSOU_RECEBER':
                return 'Recusou Receber';
            default:
                return 'Status Desconhecido';
        }
    },
    getStatusDescription(status) {
      switch (status) {
          case 'AGUARDANDO':
              return 'Seu pedido está aguardando confirmação.';
          case 'RECEBIDO':
              return 'Seu pedido foi confirmado, e em breve será preparado.';
          case 'CANCELADO':
              return 'Seu pedido foi cancelado.';
          case 'ENVIADO':
              return 'Seu pedido está a caminho, sendo entregue pelo motoboy.';
          case 'PREPARANDO':
              return 'Seu pedido está sendo preparado.';
          case 'ENTREGUE':
              return 'Seu pedido foi entregue com sucesso.';
              case 'PROCESSANDO_PAGAMENTO':
              return 'Seu pagamento está sendo processado';              
          case 'PRONTOPARARETIRADA':
              return 'Seu pedido está pronto para retirada.';
          case 'PRONTOPARAENTREGA':
              return 'Seu pedido está pronto para ser entregue.';
          case 'PROCESSANDO_PAGAMENTO':
              return 'Seu pagamento está sendo processado.';
          case 'ENDERECO_NAO_LOCALIZADO':
              return 'Não foi possível localizar o endereço de entrega.';
          case 'RECUSOU_RECEBER':
              return 'O destinatário recusou a entrega.';
          default:
              return 'Status desconhecido.';
      }
    },
    fetchData() {
      if(!Cookies.get(this.$route.params.id)){
        this.$router.push('/' + this.$router.currentRoute.params.empresa + '/menu');
      }
      axios.get(this.$store.state.apiUrl + 'empresa/' +this.$router.currentRoute.params.empresa + '/pedidos/rastrear/' + Cookies.get(this.$route.params.id))
        .then(res => {
          this.isLoading = false;
          this.retorno = res.data;
          this.forma_pagamento = this.retorno.pedido.forma_pagamento;
          if(this.retorno.pedido.forma_pagamento == 'PAGHIPER_PIX' && this.retorno.pedido.status == 'PROCESSANDO_PAGAMENTO'){
            this.RealizarPagamentoPagHiperPix(res.data.pagamento.dadosPagamento);
          } else if(this.retorno.pedido.forma_pagamento == 'MERCADOPAGO_PIX' && this.retorno.pedido.status == 'PROCESSANDO_PAGAMENTO'){
            this.RealizarPagamentoMercadPagoPix(res.data.pagamento.dadosPagamento);
          }
          else if(this.retorno.pedido.forma_pagamento == 'MERCADOPAGOLINK'){
            this.link_pagamento_chave_rastreamento = "pagamentos/mercadopago/rastrear/" + res.data.pagamento.dadosPagamento.chave_rastreamento;
            this.link_pagamento = decodeURI(res.data.pagamento.dadosPagamento.linkPagamento).replace(/\\/g, '').replace(/^"(.*)"$/, '$1');
          }
          this.checkStatus();
        })
        .catch(err => {
          this.isLoading = false;
          console.log(err.response);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    checkStatus() {
      if (this.retorno && this.retorno.historico && this.retorno.historico.length > 0) {
        const lastItem = this.retorno.historico[this.retorno.historico.length - 1];
        const status = lastItem.status;
        if (['CANCELADO', 'ENTREGUE', 'ENDERECO_NAO_LOCALIZADO', 'RECUSOU_RECEBER'].includes(status)) {
          clearInterval(this.interval);
          console.log('Interval stopped due to status:', status);
          this.liberarBotaoAtualizar = false;
        }else{
          setTimeout(() => {
            this.liberarBotaoAtualizar = true;
          }, 1 * 60 * 1000);
        }
      }
    },
    RealizarPagamentoMercadPagoPix(data) {

      console.log(data)
      if(data){
        this.mercadopago_pix_gerado = true;
        this.mercadopago_pix = data;
        this.mercadopago_pix.chave_rastreamento = data.chave_rastreamento;
        this.mercadopago_pix.link_pagamento = data.checkout_preferences_body_response.point_of_interaction.transaction_data.ticket_url;
        this.mercadopago_pix.codigo_copia_cola = data.checkout_preferences_body_response.point_of_interaction.transaction_data.qr_code;;
        this.mercadopago_pix.imagem_qrcode = data.checkout_preferences_body_response.point_of_interaction.transaction_data.qr_code_base64;;
        // this.mercadopago_pix.imagem_qrcode = this.mercadopago_pix.imagem_qrcode.replace(/^"(.*)"$/, '$1')
        this.isLoading = false;

        $("#MERCADOPAGO_PIX_CAIXA_PAGAMENTO").show();
        setTimeout(() => {
          document.getElementById("MERCADOPAGO_PIX_CAIXA_PAGAMENTO").scrollIntoView({behavior: 'smooth'});

          this._mercadopago_checar_pagamento_intervalo = setInterval(this.ConsultarStatusPagamento, 15000);
          setTimeout(() => {
            clearInterval(this._mercadopago_checar_pagamento_intervalo);
            console.log("Intervalo interrompido após um período.");
          }, 300000);

        }, 500);
      } else {
        Swal.fire({
            title: 'Aviso!',
            text: 'Ocorreu um erro ao gerar o Pix para pagamento! Tente novamente',
            icon: 'error',
            customClass: {confirmButton: 'confirm-button-class materialize-red'}
          });
      }

    },
    RealizarPagamentoPagHiperPix(data) {
      this.paghiper_pix.gerado = true;
      this.paghiper_pix.codigo_copia_cola = data.codigo_copia_cola;
      this.paghiper_pix.imagem_qrcode = data.imagem_qrcode;
      this.paghiper_pix.chave_rastreamento = data.chave_rastreamento;

      console.log('Pag,', this.paghiper_pix)
      $("#PAGHIPER_PIX_CAIXA_PAGAMENTO").show();
      setTimeout(() => {
        document.getElementById("PAGHIPER_PIX_CAIXA_PAGAMENTO").scrollIntoView({behavior: 'smooth'});
        this._paghiper_checar_pagamento_intervalo = setInterval(this.ConsultarStatusPagamentoPagHiper, 15000);
        setTimeout(() => {
          clearInterval(this._paghiper_checar_pagamento_intervalo);
          console.log("Intervalo interrompido após um período.");
        }, 300000);

      }, 500);
    },
    ConsultarStatusPagamento() {
      let chaveRastreamento = '';

      if(this.forma_pagamento == 'MERCADOPAGO_PIX'){
        chaveRastreamento = this.mercadopago_pix.chave_rastreamento;
      }
      if(this.forma_pagamento == 'MERCADOPAGO_CARTAO'){
        chaveRastreamento = this.mercadopago_pagamento_chave_rastreamento;
      }

      $.ajax({
        url: this.$store.state.apiUrl + "mercadopago/pagamentos-pre-pagamento?rastrear=" + chaveRastreamento,
        type: "GET",
        success: (data) => {
            if(data.status == 'PAGO'){
              if(this.forma_pagamento == 'MERCADOPAGO_PIX'){
                this.mercadopago_pix_pagamento_realizado = true;
              }
              if(this.forma_pagamento == 'MERCADOPAGO_CARTAO'){
                this.mercadopago_pagamento_realizado = true;
              }
              clearInterval(this._mercadopago_checar_pagamento_intervalo);
              this.EnviarPedido()
            }
        },
        error: (data) => {
        }
      });
    },
    PodeEnviarPedido(){

      const createdAtDate = new Date(this.retorno.pedido.created_at);
      const today = new Date();
      const isSameDate = createdAtDate.getFullYear() === today.getFullYear() &&
                   createdAtDate.getMonth() === today.getMonth() &&
                   createdAtDate.getDate() === today.getDate();

      if(isSameDate){
        switch (this.retorno.pedido.status) {
          case 'AGUARDANDO': return true;
          case 'RECEBIDO': return true;
          case 'CANCELADO': return false;
          case 'ENVIADO': return false;
          case 'PREPARANDO': return false;
          case 'ENTREGUE': return false;
          case 'PROCESSANDO_PAGAMENTO': return false;        
          case 'PRONTOPARARETIRADA': return false;
          case 'PRONTOPARAENTREGA': return false;
          case 'PROCESSANDO_PAGAMENTO': return false;
          case 'ENDERECO_NAO_LOCALIZADO': return false;
          case 'RECUSOU_RECEBER': return false;
          default: return false;
        }
      } else {
        return false;
      }
    },
    ConsultarStatusPagamentoPagHiper() {
      let chaveRastreamento = this.paghiper_pix.chave_rastreamento;
      $.ajax({
        url: this.$store.state.apiUrl + "paghiper/consultar-pagamento-pix/" + chaveRastreamento,
        type: "GET",
        success: (data) => {
            if(data.status == 'PAGO'){
              this.retorno.pagamento.status = 'PAGO';
              this.paghiper_pix.pagamento_realizado = true;
              clearInterval(this._paghiper_checar_pagamento_intervalo);
              this.EnviarPedido();
            }
        },
        error: (data) => {

        }
      });
    },
    async EnviarPedido(){
        if (this.$store.state.empresa.receber_pedidos_whatsapp == "S")
          this.EnviarParaWhatsApp();

        Swal.fire({
          title: 'Obrigado!</br>' +  this.retorno.pedido.nome_cliente,
          icon: 'success',
          customClass: {confirmButton: 'confirm-button-class cor-primaria-bg'},
          onClose: () => {
            location.reload();
          }
        });
    },
    ObterValorFrete() {
      var valor = (parseFloat(this.$store.state.empresa.taxa_entrega)).toFixed(2);
      if (valor == "0.00") {
        return this.taxa_entrega_v2;
      } else {
        return 'R$ ' + valor;
      }
    },
    PrepararLista() {
      let objList = this.retorno.pedido.itens;
      objList = JSON.parse(JSON.stringify(objList));

      console.log(objList)

      let uniqueList = [];
      let dupList = [];

      Array.prototype.contains = function (item) {
        let filtered_item = this.filter((i) => {
          return (i.id === item.id) &&
            (item.adicionais && item.adicionais.length == 0) &&
            (item.categorias && item.categorias.length == 0) &&
            (i.observacao_cliente == item.observacao_cliente);
        });
        return !!filtered_item.length;

      }

      // function contains(list, item) {
      //   let filtered_item = list.filter((i) => {
      //     return i.id === item.id && item.adicionais.length == 0 && item.categorias.length == 0 && i.observacao_cliente == item.observacao_cliente
      //   });
      //   return !!filtered_item.length;
      // }

      function pushToUniqueList(item) {
        uniqueList.push(item);
      }

      function pushToDuplicateList(item) {
        dupList.push(item);
      }

      for (let i = 0; i < objList.length; i++) {
        if (uniqueList.contains(objList[i])) {
          pushToDuplicateList(objList[i]);
        } else {
          pushToUniqueList(objList[i]);
        }
      }

      /// Nova verificação
      var listaCondensadaB = [];
      for (let i = 0; i < objList.length; i++) {
        if (dupList.contains(objList[i])) {
          var res = objList[i];
          listaCondensadaB[res.id] = res.quantidade + (listaCondensadaB[res.id] ? listaCondensadaB[res.id] : 0);
          objList[i].quantidade = res.quantidade + (listaCondensadaB[res.id] ? listaCondensadaB[res.id] : 0);
          const index = objList.indexOf(i);
          if (index > -1) {
            objList.splice(index, 1);
          }
        }
      }

      let objListT = objList;

      let uniqueListT = [];
      let dupListT = [];

      Array.prototype.containsT = function (item) {
        let filtered_item = this.filter((i) => {
          return (i.id === item.id) &&
            (item.adicionais && item.adicionais.length == 0) &&
            (item.categorias && item.categorias.length == 0) &&
            (i.observacao_cliente == item.observacao_cliente);
        });
        return !!filtered_item.length;
      }

      function containsT(list, item) {
        let filtered_item = list.filter((i) => {
          return i.id === item.id && item.adicionais.length == 0 && item.categorias.length == 0 && i.observacao_cliente == item.observacao_cliente
        });
        return !!filtered_item.length;
      }

      function pushToUniqueListT(item) {
        if (!uniqueListT.containsT(item)) uniqueListT.push(item);
      }

      function pushToDuplicateListT(item) {
        if (!dupListT.containsT(item)) dupListT.push(item);
      }

      for (let i = 0; i < objListT.length; i++) {
        if (uniqueListT.containsT(objListT[i])) {
          pushToDuplicateListT(objListT[i]);
        } else {
          pushToUniqueListT(objListT[i]);
        }
      }

      return uniqueListT;

    }, //forma_pagamento
    FormatarFormaPagamento(forma) {
      let formaPagemento = forma;
      switch (formaPagemento) {
        case 'VALE_ALIMENTACAO':
          formaPagemento = 'Vale Alimentação'
          break;
        case 'VALE_REFEICAO':
          formaPagemento = 'Vale Refeição'
          break;
        case 'MERCADOPAGO_PIX':
          formaPagemento = 'PIX Online'
          break;
        case 'MERCADOPAGO_CARTAO':
          formaPagemento = this.mercadopago_pagamento_cartao_descricao_forma_pagamento;
          break;
        case 'PAGHIPER_PIX':
          formaPagemento = 'PIX Online'
          break;
        case 'SOFTEXPRESS_CARTAO':
          formaPagemento = 'Cartão de Crédito - Final: ***' + $('#softwareExpressNumero').val().slice(-4)
          break;
      }
      return formaPagemento;
    }, 
    EnviarParaWhatsApp() {
      var pedidoStore = this.retorno.pedido;
      pedidoStore.itens = this.PrepararLista();
      pedidoStore.conta_bancaria = this.conta_bancaria
      let pedido = new WMCompose();

      var strNumPedido = pedidoStore.numero_pedido.toString();
      var pad = "00000"
      strNumPedido = pad.substring(0, pad.length - strNumPedido.length) + strNumPedido

      pedido.writeText("*Pedido #" + strNumPedido + "* - _" + this.$store.state.empresa.nome + "_");
      pedido.writeText("===============================", 1);
      pedido.writeText("*SEGUNDA VIA DO PEDIDO*", 1);
      pedido.writeText("===============================", 1, 1);
      console.log(pedidoStore.itens)
      pedidoStore.itens.forEach(item => {
        pedido.writeText("*" + item.quantidade + 'x ' + item.produto_nome + "* - R$ " + (item.quantidade * parseFloat(item.valor_unitario)).toFixed(2), 1);

        if (this.$store.state.empresa.mostrar_categoria_wpp == "S" && item.categorias) {
          item.categorias.forEach(categoria => {
            pedido.writeText("  *" + categoria.descricao + "*", 1);
            categoria.adicionais.forEach(adicional => {
              pedido.writeText("    " + (adicional.quantidade * item.quantidade) + 'x ' + adicional.nome + " - R$ " + (parseFloat(adicional.valor * adicional.quantidade * item.quantidade).toFixed(2)), 1);
            });
          });
        } else {
          item.adicionais.forEach(adicional => {
            pedido.writeText("    " + (adicional.adicional_quantidade * item.quantidade) + 'x ' + adicional.adicional_nome + " - R$ " + (parseFloat(adicional.adicional_valor * adicional.adicional_quantidade * item.quantidade).toFixed(2)), 1);
          });
        }

        if (item.observacao_cliente && item.observacao_cliente !== '.')
          pedido.writeText("*Obs:* _" + item.observacao_cliente + "_", 1);
      });

      pedido.writeText("------------------------------------", 1);

      pedido.writeText("*Subtotal: R$ " + pedidoStore.subtotal + "*", 1, 1);

      if (this.$store.state.cupom_desconto_valor > 0)
        pedido.writeText("*Cupom de Desconto: R$ " + parseFloat(this.$store.state.cupom_desconto_valor).toFixed(2) + "*", 1, 1);

      if (pedidoStore.valor_desconto > 0){
        pedido.writeText("*Desconto: R$ " + parseFloat(pedidoStore.valor_desconto).toFixed(2) + "*", 1, 1);
      }else if(pedidoStore.valor_desconto < 0){
        pedido.writeText("*Acréscimo: R$ " + parseFloat(pedidoStore.valor_desconto *-1).toFixed(2) + "*", 1, 1);
      }

      function toFloat(value) {
        return parseFloat(String(value).replace(/[^\d,.-]/g, '').replace(',', '.')) || 0;
      }      

      let frete = toFloat(pedidoStore.taxa_entrega);
      let taxaRetorno = toFloat(pedidoStore.taxa_retorno_maquina);
      let taxaRetornoTroco = toFloat(pedidoStore.taxa_retorno_maquina_troco);
      let totalTaxa = 0.0;

      if (frete > 0 && (taxaRetorno > 0 || taxaRetornoTroco > 0)) {
        let totalTaxasRetorno = taxaRetorno + taxaRetornoTroco;
        totalTaxa = frete > totalTaxasRetorno
          ? frete - totalTaxasRetorno
          : totalTaxasRetorno - frete;
      } else {
        totalTaxa = frete > 0 ? frete : (taxaRetorno + taxaRetornoTroco);
      }

      console.log(`Subtotal: R$ 21.50`);
      console.log(`Taxa Frete: ${this.ObterValorFrete()}`);
      console.log(`Taxa de entrega: ${totalTaxa}`);
      console.log(`Taxa retorno maquininha: ${taxaRetorno}`);
      console.log(`Taxa retorno troco: ${taxaRetornoTroco}`);
      console.log(`Total: R$ ${21.50 + frete + taxaRetorno}`);      

      if (pedidoStore.forma_entrega == "ENTREGA")
        pedido.writeText("*Taxa de entrega: " + frete + "*", 1, 1)
      //this.forma_entrega == 'ENTREGA' ? this.$store.getters.pedidoTotal : this.$store.getters.pedidoSubtotal
      //pedido.writeText("*Total: R$ " + (this.$store.getters.pedidoTotal).toFixed(2)+"*", 1)
      
      if (pedidoStore.taxa_retorno_maquina > 0) {
        pedido.writeText("*Taxa retorno maquininha: " + parseFloat(pedidoStore.taxa_retorno_maquina).toFixed(2) + "*", 1, 1);
      }

      if (pedidoStore.taxa_retorno_troco > 0) {
        pedido.writeText("*Taxa retorno troco: " + parseFloat(pedidoStore.taxa_retorno_troco).toFixed(2) + "*", 1, 1);
      }

      pedido.writeText("*Total: R$ " + (parseFloat(pedidoStore.valor_total)).toFixed(2) + "*", 1);
      pedido.writeText("------------------------------------", 1);

      if (this.$store.state.empresa.habilitar_entrega == 'S') {
        pedido.writeText("*Como deseja receber o pedido?*", 1);
        pedido.writeText("```" + pedidoStore.forma_entrega + "```", 1);

        if (pedidoStore.forma_entrega == 'ENTREGA' && this.$store.state.empresa.mostrar_somente_bairro == 'N') {
          pedido.writeText("*Endereço de Entrega*", 2);
          pedido.writeText("*" + pedidoStore.entrega_endereco + ", " + (pedidoStore.entrega_numero || "S/N") + (pedidoStore.entrega_complemento ? " - " + pedidoStore.entrega_complemento : "") + "*", 1);
          pedido.writeText("*" + pedidoStore.entrega_bairro + ", " + pedidoStore.entrega_cidade + "/" + pedidoStore.entrega_uf + "*", 1);
          if (pedidoStore.entrega_cep)
            pedido.writeText("*" + pedidoStore.entrega_cep.replace(/(\d{5})/g, "\$1-") + "*", 1);
        }

        if (pedidoStore.forma_entrega == 'ENTREGA' && this.$store.state.empresa.mostrar_somente_bairro == 'S') {
          pedido.writeText("*Endereço de Entrega*", 2);
          pedido.writeText("*" + pedidoStore.entrega_endereco + ", " +  (pedidoStore.entrega_complemento ? " - " + pedidoStore.entrega_complemento : "") + "*", 1);
          pedido.writeText("*" + pedidoStore.entrega_bairro + ", " + pedidoStore.entrega_cidade + "/" + pedidoStore.entrega_uf + "*", 1);
        }
      }

      pedido.writeText("*Forma de Pagamento:* " + " " + this.FormatarFormaPagamento(pedidoStore.forma_pagamento), 2);
      // pedido.writeText("*"+this.FormatarFormaPagamento(pedidoStore.forma_pagamento)+"*", 1);//"```" + + "```"

      if (pedidoStore.forma_pagamento == "MERCADOPAGOLINK") {
        pedido.writeText("*Link de Pagamento*", 2);
        pedido.writeText(this.link_pagamento, 1);

        pedido.writeText("*Visualizar Status do Pagamento*", 2);
        pedido.writeText(this.$store.state.empresa.sirrus_delivery_link + "pagamentos/mercadopago/rastrear/" + this.link_pagamento_chave_rastreamento, 1);
      }

      if (pedidoStore.forma_pagamento == "PIX") {
        // pedido.writeText("*Chave*", 2);
        let forma_pagamento_texto_amigavel = '';
        switch (this.$store.state.empresa.pagamento_pix_chave_tipo) {
          case("CHAVE_ALEATORIA"):
            forma_pagamento_texto_amigavel = "*Chave Aleatória*";
            break;
          case("CELULAR"):
            forma_pagamento_texto_amigavel = "*Celular*";
            break;
          case("CPF_CNPJ"):
            forma_pagamento_texto_amigavel = "*CPF/CNPJ*";
            break;
          case("EMAIL"):
            forma_pagamento_texto_amigavel = "*E-mail*";
            break;
        }

        // pedido.writeText("```" + forma_pagamento_texto_amigavel + "```"+": "+this.$store.state.empresa.pagamento_pix_chave , 1);
        pedido.writeText("*Chave*" + " " + forma_pagamento_texto_amigavel + ": *" + this.$store.state.empresa.pagamento_pix_chave + "*", 1);
        pedido.writeText("*Beneficiário*: " + this.$store.state.empresa.pagamento_pix_nome_conta, 1);

        // pedido.writeText("*PIX - Chave Pagamento:*", 1);
        // pedido.writeText("```" + this.$store.state.empresa.pagamento_pix_chave + "```", 1);
      }

      if (pedidoStore.precisa_troco == "S") {
        pedido.writeText("*Precisa de troco?*", 2);
        pedido.writeText("Sim, para R$" + pedidoStore.troco_para_quanto, 1);
      }


      if (pedidoStore.conta_bancaria) {
        if (((pedidoStore.conta_bancaria.ativo === "S") && (pedidoStore.forma_pagamento === "TRANSFERENCIA"))) {
          pedido.writeText("*Conta Selecionada*", 2);
          pedido.writeText("Banco: " + pedidoStore.conta_bancaria.banco.nome + " (" + pedidoStore.conta_bancaria.banco.codigo + ")", 1);
          pedido.writeText("Agência: " + pedidoStore.conta_bancaria.agencia, 1);
          pedido.writeText("Conta: " + pedidoStore.conta_bancaria.conta, 1);
          pedido.writeText("Tipo Conta: " + pedidoStore.conta_bancaria.tipo_conta, 1);
          pedido.writeText("Titular: " + pedidoStore.conta_bancaria.nome, 1);
          pedido.writeText("CPF/CNPJ: " + pedidoStore.conta_bancaria.cpf_cnpj, 1);
          if (pedidoStore.conta_bancaria.informacoes_adicionais) {
            pedido.writeText("Observações: " + pedidoStore.conta_bancaria.informacoes_adicionais, 1);
          }
        }
      }

      if (this.bandeira_vale_alimentacao) {
        pedido.writeText("*Bandeira Selecionada*", 2);
        pedido.writeText("" + this.bandeira_vale_alimentacao.descricao, 1);
      }

      if (this.bandeira_vale_refeicao) {
        pedido.writeText("*Bandeira Selecionada*", 2);
        pedido.writeText("" + this.bandeira_vale_refeicao.descricao, 1);
      }


      pedido.writeText("*Cliente:* " + pedidoStore.nome_cliente, 2);
      pedido.writeText("*Telefone:* " + pedidoStore.telefone, 1);
      if (this.cpf_nota)
        pedido.writeText("*CPF:* " + this.cpf_mask(pedidoStore.cpf), 1);

      if (this.$store.state.empresa.usa_agendamento == 'S') {
        pedido.writeText("*Agendado?:* " + (pedidoStore.agendado == "S" ? "Sim" : "Não"), 2);
        if (pedidoStore.agendado == "S")
          pedido.writeText("*Agendado para:* " + pedidoStore.data_agendamento + ' ' + pedidoStore.hora_agendamento, 1);
      }

      pedido.writeText("*Tempo médio de entrega:* " + this.$store.state.empresa.tempo_medio_entrega, 2);

      if (pedidoStore.observacoes) {
        pedido.writeText("*" + this.$store.state.empresa.label_observacoes + ":* " + pedidoStore.observacoes, 2);
      }

      var horaAtual = new Date();
      var strHoraAtual = moment().format('HH:mm');
      var strDataAtual = moment().format('DD/MM/YYYY');

      if (this.$router.currentRoute.query.src)
        pedido.writeText("_via " + this.$router.currentRoute.query.src + "_", 2);

      pedido.writeText("_Pedido gerado por Sirrus Sistemas em " + strDataAtual + " às " + strHoraAtual + "_", 2);
      console.log('Empress', this.$store.state.empresa)
      WMSend(this.$store.state.empresa.whatsapp, pedido.getText());

    },
    isInstagramOnIOS() {
        // Verifica se o user agent contém informações relacionadas ao Instagram
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const isInstagram = /Instagram/.test(userAgent);
        const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

        return isInstagram && isIOS;
    },    
  },
  mounted() {
    this.isLoading = true;
    this.fetchData();
    this.VerificarEmpresa()
    this.interval = setInterval(this.fetchData, 5 * 60 * 1000);
    $(document).ready(function(){
      $('.collapsible').collapsible();
    });
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
}
</script>

<style scoped>
.logo {
  padding: 9px;
  width: 210px;
}

@media only screen and (max-width : 992px) {
  .logo {
    padding-top: 7px;
    width: 185px;
  }
}

.sidenav li > a {
  color: white;
}

.nav-grupo-conteiner{
  margin-top: 50px;
  overflow-x: auto;
  white-space: nowrap;
}

.nav-grupo{
  background-color: #f2f2f2;
  /*height: 100px;*/
  height: auto;
}


nav i {
  line-height: 40px;
}

nav {
  /*color: #fff;*/
  /*background-color: #ee6e73;*/
  /*width: 100%;*/
  line-height: 45px;
}

.timeline {
  position: relative;
  .timeline-event {
    position: relative;
    padding-top: 5px;
    padding-bottom: 5px;
    .timeline-content {
      position: relative;
      width: calc(50% - 50px);
    }
    &::before {
      display: block;
      content: "";
      width: 2px;
      height: calc(50% - 30px);
      position: absolute;
      background: #d2d2d2;
      left: calc(50% - 1px);
      top: 0;
    }
    &::after {
      display: block;
      content: "";
      width: 2px;
      height: calc(50% - 30px);
      position: absolute;
      background: #d2d2d2;
      left: calc(50% - 1px);
      top: calc(50% + 30px);
    }
    &:first-child::before, &:last-child::after {
      display: none;
    }
    &:nth-child(even) .timeline-content {
      margin-left: calc(50% + 50px);
    }
    &:nth-child(odd) .timeline-content {
      margin-left: 0;
    }
  }
  .timeline-badge {
    display: block;
    position: absolute;
    width: 26px;
    height: 26px;
    background: #d2d2d2;
    top: calc(50% - 8px);
    right: calc(50% - 8px);
    border-radius: 50%;
    text-align: center;
    cursor: default;
    span {
      font-size: 20px;
      line-height: 26px;
    }
  }
}

@media (max-width: 600px) {
  .timeline {
    .timeline-event {
      .timeline-content {
        width: calc(100% - 70px);
      }
      &::before, &::after {
        left: 19px;
      }
      &:nth-child(even) .timeline-content, &:nth-child(odd) .timeline-content {
        margin-left: 70px;
      }
    }
    .timeline-badge {
      left: 12px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Paginas/Pedido/StatusPedido.vue